import React, { useCallback, useEffect, useState } from 'react';
import { Checkbox, IView, TextField } from '@framework-controls/core';
import { JSXIf } from '@framework-controls/jsxconditions';
import { IconNoImage } from 'src/content/icons';
import { strings } from 'src/localization';
import vehcss from '../AddVehicle.module.scss';
import css from './MobileView.module.scss';
import { ApptVeh, NewVehicle, RDWMakes, RDWModels, RDWYears, SpecData, ascCtaInteractionInput, ascFormEngagementInput, ascPageviewInput, ascElementConfigurationInput } from 'src/models';
import PropertyDropDown from '../PropertyDropDown/PropertyDropDown';
import { IPropertyList } from '../DesktopPane/PropertyOptions/PropertyOptions';
import VinInput from '../VinInput/containers/VinInput';
import TextInCircle from 'src/components/TextInCircle/TextInCircle';
// import { lowerCase } from 'lodash';
import UpdateMileage from '../UpdateMileage/containers/UpdateMileage';
import { ascCtaInteraction, ascFormEngagement, ascPageview, getElementColor, ascElementConfiguration } from 'src/helpers/EventHelper/EventHelper';
import { ComponentMapIds } from 'src/components/map';
// import { colors } from '../colors';

interface IProps {
    optionsSelected?: NewVehicle;
    vehicleSpecs?: SpecData;
    vinSpecFlag: string;
    theme: string;
    estMileageChangedHandler: (id: string, value: string) => void;
    onAddNewVehicle: (state: NewVehicle) => void;
    rdwYears?: RDWYears[];
    rdwMakes?: RDWMakes[];
    rdwModels?: RDWModels[];
    makesBuilt: boolean;
    modelsBuilt: boolean;
    yearsBuilt: boolean;
    mainPaneViewOrder: IView[];
    newVehicleInfo: NewVehicle | undefined;
    getMakes?: (year: string) => void;
    getModels?: (year: string, makeId: string) => void;
    getStyles?: (year: string, make: string, model: string) => void;
    getYears?: () => void;
    selectedVehicle: ApptVeh;
    updateVehicleMileage: (mileage: number) => void,
    prevMileage: string,
    defaultLen: number,
    Itype: string | undefined;
    sessionId: string;
    lexusMCLaunched: string;
    toyotaMCLaunched: string;
    lexusTDMCLaunched: string;
    toyotaTDMCLaunched: string;
}

const MobileView = (props: IProps) => {
    /*  const colors: IDropDownItem[] = [
        { label: strings.SelectColor, value: 'default' },
        { label: strings.Black, value: strings.Black },
        { label: strings.Blue, value: strings.Blue },
        { label: strings.Brown, value: strings.Brown },
        { label: strings.Copper, value: strings.Copper },
        { label: strings.Gold, value: strings.Gold },
        { label: strings.Gray, value: strings.Gray },
        { label: strings.Green, value: strings.Green },
        { label: strings.Maroon, value: strings.Maroon },
        { label: strings.Orange, value: strings.Orange },
        { label: strings.Pink, value: strings.Pink },
        { label: strings.Purple, value: strings.Purple },
        { label: strings.Red, value: strings.Red },
        { label: strings.Silver, value: strings.Silver },
        { label: strings.Tan, value: strings.Tan },
        { label: strings.Teal, value: strings.Teal },
        { label: strings.White, value: strings.White },
        { label: strings.Yellow, value: strings.Yellow },
        { label: strings.DiffColor, value: 'other' },
    ]; */
    const [pageViewEvent, setPageViewEvent] = useState(false);
    const { optionsSelected, vehicleSpecs,
        estMileageChangedHandler, vinSpecFlag } = props;
    const { vin, vinValid, make, year, model, makeId, estMileage } = optionsSelected!;
    // See if the current color exists in the color list, if not set color dropdown to "other" and fill in the textfield
    /*  let initColor = color;
    let initDifferentColor = '';
    const colorExistsInList = colors.find((col) => col.value === color);
    if (!colorExistsInList) {
        initColor = 'other';
        initDifferentColor = color;
        if (color === '') {
            initColor = 'default';
        }
    } */
    /* const [selectedColor, setSelectedColor] = useState(initColor);
    const [differentColor, setDifferentColor] = useState(initDifferentColor); */

    const showVin = vinSpecFlag !== 'H' && !!!make;
    const showMakeDropDown = ((vinSpecFlag !== 'R') || (vinValid) || !!make);
    const showYearDropDown = !!make;
    let showModelDropDown = !!year && ((props.rdwModels && props.rdwModels.length > 0) || !!model);
    // When there is only one model, we dont get an array back
    // So if rdwModels exists but we have no length, we are getting a single object
    // as such we have one model and we should show the model dropdown
    if (props.rdwModels && props.rdwModels.length === undefined) {
        showModelDropDown = true;
    }
    const showEstMil = !!model || ((!props.rdwModels || props.rdwModels.length === 0) && !!year);
    // const showColorList = !!trim || (!props.rdwStyles && !!model);
    // const showColorTxtFld = selectedColor === 'other';
    const estMileageDisabled = estMileage === 'Unknown';
    const currentMainPane = props.mainPaneViewOrder[props.mainPaneViewOrder.length - 1].viewId;

    let makeLit = make;

    if (makeLit === 'Ford Canada') {
        makeLit = 'Ford';
    }

    if (makeLit === 'Chrysler Canada') {
        makeLit = 'Chrysler';
    }

    if (makeLit === 'Vw Canada') {
        makeLit = 'Volkswagen';
    }

    if (makeLit === 'Bmwi') {
        makeLit = 'BMW';
    }

    if (makeLit === 'Honda Mtc/pp/pe') {
        makeLit = 'Honda';
    }

    if (makeLit === 'Cummins Mid-canada') {
        makeLit = 'Cummins';
    }

    if (makeLit === 'Discover Canada') {
        makeLit = 'Discover';
    }

    useEffect(() => {
        if (!props.rdwMakes || props.rdwMakes.length === 0) {
            if (props.getMakes) {
                props.getMakes('');
            }
        }
    }, [props.getMakes, props.rdwMakes, vin]);

    useEffect(() => {
        let varMakeId = makeId;
        // const varMake = lowerCase(make);
        const varMake = make.toLowerCase();
        if (varMake === 'ford truck') {
            if (props.rdwMakes) {
                const varRDWMakes = props.rdwMakes?.find((a) => a.makeName.text === 'Ford');
                if (varRDWMakes) {
                    varMakeId = varRDWMakes?.makeId.text;
                }
            }
        }
        if (varMake === 'general motors') {
            if (props.rdwMakes) {
                const varRDWMakes = props.rdwMakes?.find((a) => a.makeName.text === 'GMC');
                if (varRDWMakes) {
                    varMakeId = varRDWMakes?.makeId.text;
                }
            }
        }
        if (varMake === 'ford canada') {
            if (props.rdwMakes) {
                const varRDWMakes = props.rdwMakes?.find((a) => a.makeName.text === 'Ford');
                if (varRDWMakes) {
                    varMakeId = varRDWMakes?.makeId.text;
                }
            }
        }
        if (varMake === 'chrysler canada') {
            if (props.rdwMakes) {
                const varRDWMakes = props.rdwMakes?.find((a) => a.makeName.text === 'Chrysler');
                if (varRDWMakes) {
                    varMakeId = varRDWMakes?.makeId.text;
                }
            }
        }
        if (varMake === 'vw canada') {
            if (props.rdwMakes) {
                const varRDWMakes = props.rdwMakes?.find((a) => a.makeName.text === 'Volkswagen');
                if (varRDWMakes) {
                    varMakeId = varRDWMakes?.makeId.text;
                }
            }
        }
        if (varMakeId === '' && model !== '' && year !== '') {
            if (props.rdwMakes) {
                const varRDWMakes = props.rdwMakes?.find((a) => a.makeName.text.toLowerCase() === varMake);
                if (varRDWMakes) {
                    varMakeId = varRDWMakes?.makeId.text;
                }
                if (props.getModels && varMakeId) {
                    props.getModels(year, varMakeId);
                }
            }
        }
        if (varMakeId === '' && model === '' && year !== '') {
            if (props.getModels) {
                props.getModels(year, varMakeId);
            }
        }

        if (varMakeId !== '' && year !== '' && model === '') {
            if (props.getModels) {
                props.getModels(year, varMakeId);
            }
        }
    }, [year, makeId, props.getModels, model, make, props.rdwMakes]);

    useEffect(() => {
        if (year !== '' && make !== '' && model !== '') {
            if (props.getStyles) {
                props.getStyles(year, make, model);
            }
        }
    }, [year, make, model, props.getStyles]);


    const makeList: IPropertyList[] = [];
    const yearList: IPropertyList[] = [];
    const modelList: IPropertyList[] = [];
    let otherMakeList: string[] = [];
    const otherYearList: string[] = [];

    if (showMakeDropDown) {
        if (props.vehicleSpecs?.validMakes && props.vehicleSpecs.validMakes.length > 0) {
            props.vehicleSpecs.validMakes.forEach((make) => {
                if (props.rdwMakes && props.rdwMakes.length > 0) {
                    const makeName = props.rdwMakes?.find((a) => a.makeName.text.toUpperCase() === make.toUpperCase());
                    const pList: IPropertyList = { name: '', image: null, id: '' };
                    pList.name = makeName !== undefined ? makeName.makeName.text : make;
                    pList.id = makeName !== undefined ? makeName.makeId.text : '';
                    pList.image = <IconNoImage />;
                    makeList.push(pList);
                }
            });
            if (props.vehicleSpecs.otherMakes &&
                props.vehicleSpecs.otherMakesDesc &&
                props.vehicleSpecs.otherMakesDesc.length > 0) {
                const pList: IPropertyList = { name: '', image: null };
                pList.name = 'Other Make';
                pList.image = null;
                makeList.push(pList);
                otherMakeList = vehicleSpecs?.otherMakesDesc ? vehicleSpecs.otherMakesDesc : [];

                // if (props.vehicleSpecs.otherMakesIncFlag === '+') {
                //     otherMakeList = vehicleSpecs?.otherMakesDesc ? vehicleSpecs.otherMakesDesc : [];
                // }
                // if (props.vehicleSpecs.otherMakesIncFlag === '-' && props.rdwMakes && vehicleSpecs?.otherMakesDesc) {
                // Start with the entire RDW Makes list and exclude all 'other' makes.
                // const rdwExclude = props.rdwMakes
                //     .filter(make => !vehicleSpecs?.otherMakesDesc?.find(a => a === make.makeName.text.toUpperCase()));
                // otherMakeList = rdwExclude.map(make => make.makeName.text.toUpperCase());
                // Now exclude all default makes currently shown on the site.
                //     otherMakeList = otherMakeList.filter(make => !makeList.find((a) => a.name.toUpperCase() === make));
                // }
            }
        } else if (props.rdwMakes && props.rdwMakes.length > 0) {
            // props.rdwMakes?.forEach((make) => {
            //     const pList: IPropertyList = { name: '', image: null, id: '' };
            //     pList.name = make.makeName.text;
            //     pList.id = make.makeId.text;
            //     pList.image = <IconNoImage />;
            //     makeList.push(pList);
            // });
            if (props.vehicleSpecs) {
                if (props.vehicleSpecs.otherMakes &&
                    props.vehicleSpecs.otherMakesDesc &&
                    props.vehicleSpecs.otherMakesDesc.length > 0) {
                    const pList: IPropertyList = { name: '', image: null };
                    pList.name = 'Other Make';
                    pList.image = null;
                    makeList.push(pList);
                    otherMakeList = vehicleSpecs?.otherMakesDesc ? vehicleSpecs.otherMakesDesc : [];
                }
            }
        }
    }

    if (showYearDropDown) {
        let yearCount = 0;
        if (props.rdwYears && props.rdwYears.length > 0) {
            props.rdwYears?.forEach((year) => {
                yearCount++;
                const pList: IPropertyList = { name: '', image: null };
                if (yearCount > 8) {
                    if (yearCount === 9) {
                        pList.name = 'Other Year';
                        pList.image = null;
                        yearList.push(pList);
                    }
                    otherYearList.push(year.year.text);
                } else {
                    pList.name = year.year.text;
                    pList.image = null;
                    yearList.push(pList);
                }
            });
        }
    }

    if (showModelDropDown) {
        // When there is only one model, we dont get an array back
        // so if rdwModels exists but we have no length, we are getting a single object
        // as such we have one model and we need to add it to the list
        if (props.rdwModels && props.rdwModels.length === undefined) {
            const test: RDWModels[]= Object.values(props.rdwModels);
            const pList: IPropertyList = { name: '', image: null, id: '' };
            pList.name = Object.values(test[1]).toString();
            pList.id = Object.values(test[0]).toString();
            pList.image = <IconNoImage />;
            modelList.push(pList);
        }
        if (props.rdwModels && props.rdwModels.length > 0) {
            props.rdwModels.forEach((model) => {
                const pList: IPropertyList = { name: '', image: null, id: '' };
                pList.name = model.modelName.text;
                pList.id = model.modelId.text;
                pList.image = <IconNoImage />;
                modelList.push(pList);
            });
        }
    }

    const accordionHandler = useCallback((currentProperty: string, target: any, id?: string) => {
        const options = { ...optionsSelected! };

        // if (typeof (target) === 'string') {
        options[currentProperty] = target;
        // }
        // } else {
        //     options[currentProperty] = target.id;
        // }
        let makeId = id;
        if (currentProperty === 'make') {
            if (!id && props.rdwMakes) {
                makeId = props.rdwMakes.find(a => {
                    // In STDMakes the code JP is listed as JAG but in RDWMakes the make is spelled out as Jaguar.
                    if (target === 'JAG') {
                        return a.makeName.text.toUpperCase() === 'JAGUAR';
                    }

                    return a.makeName.text === target;
                })?.makeId.text;
            }
        }

        switch (currentProperty) {
            case 'make':
            default:
                if (props.getYears) {
                    props.getYears();
                }
                options['year'] = '';
                options['model'] = '';
                options['estMileage'] = '';
                options['color'] = 'default';
                options['makeId'] = makeId ? makeId : '';
                options['modelId'] = '';
                options['vin'] = '';
                options['vinValid'] = false;
                // setSelectedColor('default');
                break;
            case 'year':
                options['model'] = '';
                options['estMileage'] = '';
                options['color'] = 'default';
                options['modelId'] = '';
                options['vin'] = '';
                options['vinValid'] = false;
                // setSelectedColor('default');
                break;
            case 'model':
                options['estMileage'] = '';
                options['color'] = 'default';
                options['modelId'] = id ? id : '';
                options['vin'] = '';
                options['vinValid'] = false;
                // setSelectedColor('default');
                break;
            case 'color':
                break;
            // case 'estMileage':
            //     break;
        }
        props.onAddNewVehicle({ ...options });
        // props.pushToLeftPane({
        //     viewId: ComponentMapIds.PropertyOptions,
        //     component: ComponentMapIds.PropertyOptions,
        // });
    }, [optionsSelected, props.onAddNewVehicle, props.rdwMakes, props.getYears]);

    const onBlurHandler = (e: any) => {
        const newVehicle = {
            id: '',
            vin: optionsSelected?.vin ?? '',
            makeCode: optionsSelected?.makeCode ?? '',
            make: optionsSelected?.make ?? '',
            model: optionsSelected?.model ?? '',
            imagePath: '',
            year: optionsSelected?.year ?? '',
            color: optionsSelected?.year ?? '',
            style: optionsSelected?.trim ?? '',
            prevMileage: 0,
            prevRoDate: '',
            nextAppt: '',
            lastAdv: '',
            lastAdvName: '',
            lastAdvImage: '',
            lastTrans: '',
            lastTransLit: '',
            nameId: '',
        };
        const ascCtaInteractionInp : ascCtaInteractionInput = {
            pageType: 'itemlist',
            elementText: strings.EnterEstimatedMileage,
            elementColor: '',
            elementOrder: '',
            elementType: 'item_details',
            elementSubType: 'other_buttons',
            eventAction: 'click',
            eventActionResult: 'next_step',
            linkUrl: '',
        };
        ascCtaInteraction(ascCtaInteractionInp, e, [newVehicle]);
        const ascElementConfigurationInp: ascElementConfigurationInput = {
            pageType: 'service',
            elementText: strings.EnterEstimatedMileage,
            elementType: 'item_details',
            elementColor: '',
            eventAction: 'click',
            eventActionResult: 'next_step',
            linkUrl: '',
        };
        ascElementConfiguration(ascElementConfigurationInp, e);

        const ascFormEngagementInp: ascFormEngagementInput = {
            pageType: 'itemlist',
            commType: 'form',
            commStatus: 'engage',
            elementText: strings.EnterEstimatedMileage,
            department: 'service',
            formName: 'Service_Portal_2',
            formType: 'service_appointment',
        };
        ascFormEngagement(ascFormEngagementInp, [newVehicle]);
    };

    const onCheckedHandler = useCallback((id: string, e: any) => {
        if (estMileage !== 'Unknown') {
            estMileageChangedHandler(id, 'Unknown');
        } else {
            estMileageChangedHandler(id, '');
        }
        const newVehicle = {
            id: '',
            vin: optionsSelected?.vin ?? '',
            makeCode: optionsSelected?.makeCode ?? '',
            make: optionsSelected?.make ?? '',
            model: optionsSelected?.model ?? '',
            imagePath: '',
            year: optionsSelected?.year ?? '',
            color: optionsSelected?.year ?? '',
            style: optionsSelected?.trim ?? '',
            prevMileage: 0,
            prevRoDate: '',
            nextAppt: '',
            lastAdv: '',
            lastAdvName: '',
            lastAdvImage: '',
            lastTrans: '',
            lastTransLit: '',
            nameId: '',
        };
        const elementColor = getElementColor(e, 'fill');
        const ascCtaInteractionInp : ascCtaInteractionInput = {
            pageType: 'itemlist',
            elementText: strings.UnknownMileage,
            elementColor: elementColor,
            elementOrder: '',
            elementType: 'item_details',
            elementSubType: 'checkbox',
            eventAction: 'click',
            eventActionResult: 'check',
            linkUrl: '',
        };
        ascCtaInteraction(ascCtaInteractionInp, e, [newVehicle]);
        const ascElementConfigurationInp: ascElementConfigurationInput = {
            pageType: 'service',
            elementText: strings.UnknownMileage,
            elementType: 'item_details',
            elementColor: elementColor,
            eventAction: 'click',
            eventActionResult: 'check',
            linkUrl: '',
        };
        ascElementConfiguration(ascElementConfigurationInp, e);
    }, [estMileage, estMileageChangedHandler, optionsSelected]);

    /* const diffColorChangedHandler = useCallback((value: string) => {
        if (value.length <= 17) {
            setDifferentColor(value);
        }
    }, []); */

    /*  const colorChangeHandler = useCallback((value: string) => {
        const options = { ...optionsSelected! };
        setSelectedColor(value);
        setDifferentColor('');
        if (value !== 'default' && value !== 'other') {
            options['color'] = value;
            props.onAddNewVehicle({ ...options });
        } else {
            options['color'] = '';
            props.onAddNewVehicle({ ...options });
        }
    }, [optionsSelected, props.onAddNewVehicle]); */

    let cbkClassName = 'primaryCkb';
    if (estMileage === 'Unknown') {
        cbkClassName = 'primaryCkbChecked';
    }

    useEffect(() => {
        if (currentMainPane === ComponentMapIds.AddVehicle) {
            if (showEstMil) {
                setPageViewEvent(true);
            }
        }
    }, [
        currentMainPane,
        showEstMil,
    ]);

    useEffect(() => {
        if (pageViewEvent) {
            const ascPageViewInp: ascPageviewInput = {
                pageType: 'itemlist',
                errorCode: '',
                itemResults: '',
            };
            const newVehicle = {
                id: '',
                vin: props.newVehicleInfo?.vin ?? '',
                makeCode: props.newVehicleInfo?.makeCode ?? '',
                make: props.newVehicleInfo?.make ?? '',
                model: props.newVehicleInfo?.model ?? '',
                imagePath: '',
                year: props.newVehicleInfo?.year ?? '',
                color: props.newVehicleInfo?.year ?? '',
                style: props.newVehicleInfo?.trim ?? '',
                prevMileage: 0,
                prevRoDate: '',
                nextAppt: '',
                lastAdv: '',
                lastAdvName: '',
                lastAdvImage: '',
                lastTrans: '',
                lastTransLit: '',
                nameId: '',
            };
            ascPageview(ascPageViewInp, [newVehicle]);
            setPageViewEvent(false);
        }
    }, [pageViewEvent, props.newVehicleInfo]);

    // This will prevent the arrow icon from showing if the vinSpecFlag is Required or Show and the user enters a VIN
    const showIcon = (props.vinSpecFlag === 'R' || (vin && vinValid)) ? 'R' : '';

    return (
        <div id='mobileView'>
            {!props.selectedVehicle?.make || optionsSelected?.make ?
                <div>
                    <JSXIf Condition={showMakeDropDown}>
                        <PropertyDropDown
                            id='makeDropDown'
                            header={make ? `${strings.Make} - ${makeLit}` : `${strings.Make}`}
                            propertyList={makeList}
                            click={(target: EventTarget | string, id) => accordionHandler('make', target, id)}
                            open={!make}
                            selected={make}
                            allOptions={optionsSelected!}
                            otherList={otherMakeList}
                            pane={'Makes'}
                            theme={props.theme}
                            defaultLen={props.defaultLen}
                            Itype={props.Itype}
                            makesBuilt={props.makesBuilt}
                            modelsBuilt={props.modelsBuilt}
                            yearsBuilt={props.yearsBuilt}
                            currentMainPane={currentMainPane}
                            newVehicle={props.newVehicleInfo}
                            vinSpecFlag={props.vinSpecFlag}
                            vehicleSpecs={props.vehicleSpecs}
                            sessionId = {props.sessionId}
                            lexusMCLaunched = {props.lexusMCLaunched}
                            lexusTDMCLaunched = {props.lexusTDMCLaunched}
                            toyotaMCLaunched = {props.toyotaMCLaunched}
                            toyotaTDMCLaunched = {props.toyotaTDMCLaunched}
                        />
                    </JSXIf>
                    <JSXIf Condition={showYearDropDown}>
                        <PropertyDropDown
                            id='yearDropDown'
                            header={year ? `${strings.Year} - ${year}` : `${strings.Year}`}
                            propertyList={yearList}
                            click={(target: EventTarget | string, id) => accordionHandler('year', target, id)}
                            open={!year && !!make}
                            selected={year}
                            width={'8rem'}
                            height={'2.4rem'}
                            allOptions={optionsSelected!}
                            otherList={otherYearList}
                            pane={'Years'}
                            theme={props.theme}
                            defaultLen={props.defaultLen}
                            Itype={props.Itype}
                            makesBuilt={props.makesBuilt}
                            modelsBuilt={props.modelsBuilt}
                            yearsBuilt={props.yearsBuilt}
                            currentMainPane={currentMainPane}
                            newVehicle={props.newVehicleInfo}
                            vinSpecFlag={showIcon}
                            vehicleSpecs={props.vehicleSpecs}
                            sessionId = {props.sessionId}
                            lexusMCLaunched = {props.lexusMCLaunched}
                            lexusTDMCLaunched = {props.lexusTDMCLaunched}
                            toyotaMCLaunched = {props.toyotaMCLaunched}
                            toyotaTDMCLaunched = {props.toyotaTDMCLaunched}
                        />
                    </JSXIf>
                    <JSXIf Condition={showModelDropDown}>
                        <PropertyDropDown
                            id='modelDropDown'
                            header={model ? `${strings.Model} - ${model}` : `${strings.Model}`}
                            propertyList={modelList}
                            click={(target: EventTarget | string, id) => accordionHandler('model', target, id)}
                            open={!model && !!year}
                            selected={model}
                            allOptions={optionsSelected!}
                            pane={'Models'}
                            theme={props.theme}
                            defaultLen={props.defaultLen}
                            Itype={props.Itype}
                            makesBuilt={props.makesBuilt}
                            modelsBuilt={props.modelsBuilt}
                            yearsBuilt={props.yearsBuilt}
                            currentMainPane={currentMainPane}
                            newVehicle={props.newVehicleInfo}
                            vinSpecFlag={showIcon}
                            vehicleSpecs={props.vehicleSpecs}
                            sessionId = {props.sessionId}
                            lexusMCLaunched = {props.lexusMCLaunched}
                            lexusTDMCLaunched = {props.lexusTDMCLaunched}
                            toyotaMCLaunched = {props.toyotaMCLaunched}
                            toyotaTDMCLaunched = {props.toyotaTDMCLaunched}
                        />
                    </JSXIf>
                    {/* <JSXIf Condition={showColorList}>
                        <div className='colorsSelectList'>
                            <SelectList
                                id='colors'
                                value={selectedColor}
                                size='full'
                                dropDownList={colors}
                                onChange={(_, selectedColor) => colorChangeHandler(selectedColor)}
                                className={css.selectList}
                            />
                        </div>
                        <JSXIf Condition={showColorTxtFld} >
                            <div className={css.diffColorTextField}>
                                <TextField
                                    id='diffColor'
                                    label={strings.EnterDiffColor}
                                    value={differentColor}
                                    onBlur={(_, value) => {
                                        accordionHandler('color', value);
                                    }}
                                    type='text'
                                    onChange={(_, value) => diffColorChangedHandler(value)}
                                    size='full'
                                />
                            </div>
                        </JSXIf>
                                </JSXIf> */}
                    <JSXIf Condition={showEstMil}>
                        <span>{strings.SelectColorMileage + strings.RequiredFields}</span>
                        <div className={vehcss.Input}>
                            <TextField
                                id='estMileageText'
                                label={strings.EnterEstimatedMileage}
                                value={estMileage === 'Unknown'? strings.Unknown : estMileage}
                                onChange={estMileageChangedHandler}
                                disabled={estMileageDisabled}
                                onBlur={onBlurHandler}
                                type='tel'
                            />
                        </div>
                        <div className={css.mileageCheckbox}>
                            <Checkbox
                                id='estMilCheckbox'
                                checked={estMileage === 'Unknown'}
                                size='rg'
                                variant={cbkClassName}
                                labelClass={css.mileageLabel}
                                label={strings.UnknownMileage}
                                labelPlacement='end'
                                onChange={(e) => onCheckedHandler('mileageUnknown', e)}
                            />
                        </div>
                    </JSXIf>
                    <JSXIf Condition={showVin}>
                        {vinSpecFlag === 'S' ?
                            <TextInCircle
                                text={strings.OrLiteral}
                                theme={props.theme}
                            /> : null}
                        <VinInput desktopView={false} />
                    </JSXIf>
                </div> :
                <div className='updateMileage'>
                    <UpdateMileage />
                </div>
            }
        </div>
    );
};
export default MobileView;